/* "Nirvik Ready for universities and schools" (/guides/universities): its own opening, ideas and playbook around the shared chapters. */
import why from './why.md?raw';
import ideas from './ideas.md?raw';
import playbook from './playbook.md?raw';
import { audienceGuide } from '../audience';

export const universitiesGuide = audienceGuide({
  audience: 'universities',
  title: 'Nirvik Ready for universities and schools',
  subtitle:
    'How universities, colleges and schools run cyber and AI readiness for students, faculty and staff, from orientation to their own courses and workshops.',
  reviewed: '2026-10-25',
  why: {
    title: 'Why Nirvik Ready for universities and schools',
    summary: 'Students, faculty, staff and clubs',
    markdown: why,
  },
  ideas: { summary: 'Orientation, awareness month, clubs and classes', markdown: ideas },
  playbook: { summary: 'Your first semester, week by week', markdown: playbook },
});
